<script setup lang="ts">
import CheckIcon from '~icons/material-symbols-light/check';
import CheckCircleIcon from '~icons/material-symbols/check-circle';

import contactFormLocale from './ContactFormModal.locale.json';

const strings = contactFormLocale.pt.openHouse;
const nextSteps = [strings.nextSteps.brokerReview, strings.nextSteps.details];
</script>

<template>
	<div
		class="flex flex-col items-center gap-4 px-5 py-7 md:gap-6 md:py-8"
		data-testid="success-message-step"
	>
		<div class="flex w-full flex-col items-center gap-4">
			<div class="relative size-13 shrink-0 md:size-15" aria-hidden="true">
				<div
					class="absolute -left-1 -top-1 flex size-15 items-center justify-center rounded-full bg-success-light-1 md:hidden"
				>
					<div class="absolute size-10 rounded-full bg-white" />
					<CheckCircleIcon class="relative size-13 text-success" />
				</div>
				<div
					class="absolute inset-0 hidden items-center justify-center rounded-full bg-success-light-1 p-2 md:flex"
				>
					<div
						class="flex size-11 items-center justify-center rounded-full bg-success"
					>
						<CheckIcon class="size-8 text-white" />
					</div>
				</div>
			</div>
			<div class="flex w-full flex-col gap-1 text-center">
				<h3
					class="font-matter-sq text-lg font-normal leading-normal tracking-[-0.0225rem] md:text-xl md:tracking-[-0.025rem]"
					data-test-id="pdp-success-message"
				>
					{{ strings.successMessage }}
				</h3>
				<p class="text-sm leading-normal text-primary-light-1">
					{{ strings.successDescription }}
				</p>
			</div>
		</div>
		<div class="h-px w-full bg-white-dark-2" aria-hidden="true" />
		<section
			class="flex w-full flex-col gap-5"
			data-testid="open-house-next-steps"
		>
			<h3
				class="font-Inter text-base font-medium leading-[26px] tracking-normal md:font-matter-sq md:text-lg md:font-normal md:leading-normal md:tracking-[-0.0225rem]"
			>
				{{ strings.nextStepsTitle }}
			</h3>
			<ol class="flex flex-col gap-5">
				<li
					v-for="(step, index) in nextSteps"
					:key="step.title"
					class="flex items-start gap-4"
				>
					<span
						class="flex size-7 shrink-0 items-center justify-center bg-white-dark-2 text-base font-medium leading-[26px]"
						aria-hidden="true"
					>
						{{ index + 1 }}
					</span>
					<div class="flex min-w-0 flex-col gap-1 text-sm">
						<p class="font-medium leading-5">{{ step.title }}</p>
						<p class="leading-normal text-primary-light-1">
							{{ step.description }}
						</p>
					</div>
				</li>
			</ol>
		</section>
	</div>
</template>
